<template>
  <div>
    <van-popup :value="cart_show" @click-overlay="closePopup" position="bottom" :class="{'case-empty':!cart_goodslist.length}" :style="{ height: '50%', 'border-radius':'20px 20px 0 0' }">
      <div class="app-container" :class="{'case-empty-cart':!cart_goodslist.length}">
        <div class="cart-action-btn">
          <div class="flex justify-between padd5px" v-if="cart_goodslist.length">
            <div>Foods Cart (RM {{cart_subtotal}})</div>
            <van-button type="default" plain size="mini" @click="clearShoppingCart">Reset All</van-button>
          </div>
        </div>
        <div class="content-container padd5px" v-if="cart_goodslist.length">
          <div class="flex justify-between cart-item" v-for="(item, index) in cart_goodslist" :key="index">
            <van-icon name="delete" size="16" class="delete-icon" @click="delItem(item, index)" />
            <div class="flex1">
              <div class="flex">
                <div @click="editItem(item, index)" class="flex1">
                  {{ item.goods_name }}
                  <van-icon name="edit" v-if="!item.dinein_icon_color" />
                  <van-icon name="user-o" v-if="item.dinein_icon_color" :class="item.dinein_icon_color" />
                </div>
                <div class="flex justify-between basic-price-qty">
                  <div class="basic-qty">x{{item.qty}}</div>
                  <div class="basic-price">{{fmPrice(parseInt(item.qty) * parseFloat(item.price))}}</div>
                </div>
              </div>
              <div>
                <div v-if="item.optionname.length>0" class="optionname-word">
                  <span v-for="(opn, opk) in item.optionname" :key="opk">
                    <span v-if="opn" class="item-option-attr">{{ opn }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 没有商品时显示的提示信息 -->
        <div class="content-container empty-cart padd5px" v-if="!cart_goodslist.length">
          <img :src="emptycartimg" />
          <div class="empty-cart-label">{{ emptycartlabel }}</div>
          <div class="empty-cart-btn" @click="closeShoppingCart">{{ emptycartbtntxt }}</div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="show" position="bottom" class="edit-item-popup" :style="{ height: cartWinHeight }">
      <GoodsAttr :key="timeVal" :attrList="currentGood.goods_attr_list" :goods="currentGood" :chooseList="curChooseList" @evtClosePopup="closeEditPopup" @evtChooseAttr0="chooseEditAttr" @evtIsRequired="setIsRequired" />
      <div class="attr-bottom">
        <div ref="posBottom" class="pos-bottom">
          <div class="select-quanity">
            <van-stepper v-model="qty" disabled-input="true" input-width="40px" button-size="40px" @minus="getCurrentAttrTotal" @plus="getCurrentAttrTotal" />
          </div>
          <div class="goods-inventory" v-if="currentGood.counts>=1">Stock Quantity: {{currentGood.counts}} pcs</div>
          <div class="confirm-btn" :class="{'btn-on-bg':isRequired, 'btn-off-bg':!isRequired, 'no-more-item':(parseInt(currentGood.counts)>=1 && parseInt(qty)>parseInt(currentGood.counts))?true:false }" @click="updateAndSave">Confirm & Update - {{ currentAttrTotal }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { updateDishnumOfCategory, getGoodsDetail } from "@/api/api";
import { cartMixin } from "@/mixins/cartMixin";
import GoodsAttr from "@/components/common/GoodsAttr.vue";
import emptycart from "@/assets/emptycart2020.jpg"

export default {
  props: {},
  data () {
    return {
      requested: false,
      show: false,
      currentGood: {},
      ooj: {},
      productItmQty: {},
      cart_id: 0, //当前被编辑的cart_id
      cartWinHeight: "100%",
      emptycartimg: emptycart,
      emptycartlabel: "Your cart is empty!",
      emptycartbtntxt: "Continue Order",
      isRequired: false, //true所有的必选项都已经符合条件， 反之不符合条件，则不能提交确认和修改数据

      qty: 1,
      currentAttrTotal: 0.0,
      currentAttr: {},
      isSelectedAttr: false,
      timeVal: "",
      curChooseList: [], //点击当前购物车item弹窗时获取选中的规格信息
      newGoodsData: {}, //点击购物车列表中的某商品时获取到最新的数据
    };
  },
  mixins: [cartMixin],
  components: {
    GoodsAttr
  },
  computed: {
    ...mapGetters([
      "cart_show",
      "cart_goodslist",
      "cart_subtotal",
      "cart_productqty",
      "products",
      "cart_goods_addons",
      "store_info"
    ])
  },
  created () {
    const tempDemo = this.cart_goodslist.map((item, index) => {
      let strKey = item.sku + "-" + index + "-" + item.goods_id;
      item.str_key = strKey;
      this.productItmQty[strKey] = item.qty;
      return item;
    });    
  },
  methods: {
    ...mapActions({
      closePopup: "shoppping_cart/closeShoppingCart",
      cleanCart: "shoppping_cart/cleanShoppingCart",
      settingQty: "shoppping_cart/settingQty",
      settingSubtotal: "shoppping_cart/settingSubtotal",
      settingChooseList: "shoppping_cart/settingChooseList",
      settingGoodsList: "shoppping_cart/settingGoodsList",
      settingAttrRadio: "shoppping_cart/setAttrRadio",
      setRadioAddons: "shoppping_cart/settingRadioGoodsAddons",
      settingShowShoppingCart: "shoppping_cart/showShoppingCart",
      settingProductQty: "shoppping_cart/settingProductQty",
      resetCart: "shoppping_cart/resetShoppingCart"
    }),
    closeShoppingCart () {
      this.settingShowShoppingCart(false);
    },
    delItem (item, index) {
      //删除单项内容
      const itemList =
        this.cart_goodslist &&
        this.cart_goodslist.filter((i, k) => {
          if (i.str_key != item.str_key) {
            return i;
          }
        });
      this.settingGoodsList(itemList);
      setTimeout(() => {
        const strIdx = item.str_key;
        const int_qty = 0;
        const itemData = {
          o2uNum: int_qty,
          optionid: item.optionid,
          dishid: item.goods_id,
          cart_id: item.cart_id
        };
        this.updateQty(itemData);
      }, 50);
    },
    clearShoppingCart () {
      const getRouteQuery = () => {
        let tempParams = this.$route.query;
        if (tempParams.h5api == undefined) {
          tempParams["h5api"] = "on";
        }
        tempParams["do"] = "clearmenu";
        return tempParams;
      };
      const getApiParams = () => {
        return { type: "ajax" };
      };
      const queryParams = Object.assign(getRouteQuery(), getApiParams());
      this.cleanCart(queryParams).then(res => {
        // console.log('clean success');
        //  this.$toast("clear success")
      }).catch(err => { });
    },
    changeSteper (item, index) {
      setTimeout(() => {
        const strIdx = item.str_key;
        const int_qty = this.cart_productqty[strIdx];
        this.ooj = {
          old_qty: int_qty - 1,
          new_qty: int_qty,
          str_key: item.str_key
        };
        const itemData = {
          o2uNum: int_qty,
          optionid: item.optionid,
          dishid: item.goods_id
        };
        this.updateQty(itemData);
      }, 50);
    },
    async updateQty (itemData) {
      const getRouteQuery = () => {
        let tempParams = this.$route.query;
        if (tempParams.h5api == undefined) {
          tempParams["h5api"] = "on";
        }
        tempParams["do"] = "UpdateDishNumOfCategory";
        return tempParams;
      };
      const queryParams = Object.assign(getRouteQuery(), itemData, {
        optype: ""
      });
      // console.log("购物车更新", queryParams);
      updateDishnumOfCategory("/app/index.php", queryParams)
        .then(res => {
          // console.log("购物车更新", res);
          const oojStrkey = this.ooj.str_key;
          if (res.message.code == 0) {
            this.$toast(
              res.message.msg || "there are not items in your cartx!!!!"
            );
            this.cart_productqty[oojStrkey] = this.ooj.old_qty;
          } else {
            const newCartItemQty = Object.assign(this.cart_productqty, {
              [oojStrkey]: itemData.o2uNum
            });
            this.settingProductQty(newCartItemQty);

            const apiResData = {
              totalprice: res.message.totalprice,
              totalcount: res.message.totalcount,
              cart: res.message.cartList
            };
            const chooseList = () => {
              let arrList = {};
              apiResData.cart &&
                apiResData.cart.forEach(cartItem => {
                  if (!arrList[cartItem.sku]) {
                    arrList[cartItem.sku] = [];
                  }
                  arrList[cartItem.sku].push(
                    cartItem.total +
                    "X " +
                    cartItem.optionname +
                    "(+RM " +
                    cartItem.price +
                    ")"
                  );
                });
              return arrList;
            };
            setTimeout(() => {
              // this.resetCart(apiResData)
              this.settingQty(apiResData.totalcount);
              this.settingSubtotal(apiResData.totalprice);
              this.settingChooseList(chooseList());
            }, 10);
          }
        })
        .catch(error => {
          // console.log("购物车更新====>error", error);
        });
    },
    editItem (goodItem, index) {
      const whereJson = this.getUrlParams({ 'do': 'getProductById', 'id': goodItem.goods_id })
      getGoodsDetail('/app/index.php', whereJson).then(res => {
        const item = res.data
        this.newGoodsData = item
        let counts = parseInt(item.counts), today_counts = parseInt(item.today_counts)
        // response todo begin
        if (counts == -1) {
          this.editCartItemData(goodItem, index)
        } else if (counts == 0 || (counts - today_counts) <= 0) {
          this.delItem(goodItem, index)
          this.$toast("Oops, we regret to inform you that this product is out of stock")
        } else {
          const table_type = this.store_info.table_type
          if (this.store_info.is_24_hours_operation == 0 && this.store_info.is_rest != 1 || this.store_info.is_show != 1) {
            this.clearShoppingCart()
            this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
          } else {
            if (table_type && this.store_info[table_type] == 0) {
              this.$toast(this.store_info.table_type_error)
            } else if (parseInt(goodItem.qty) > 0 && parseInt(goodItem.qty) > (counts - today_counts)) {
              this.delItem(goodItem, index)
              this.$toast("No more stock for this item!!")
            } else {
              this.editCartItemData(goodItem, index)
            }
          }
        }
        // response todo end 
      }).catch((error) => {
        console.log('====>error', error)
        this.$toast('Sorry, System busy. Please try it again later.')
      })
    },
    editCartItemData (goodItem, index) {
      this.setRadioAddons(""); //先设置默认值
      this.cart_id = goodItem.cart_id;
      this.currentGood = {};
      const curList = this.products;

      //此行无业务信息，只为了用户在每次打开指定组件时，触发指定组件的 created,mounted 钩子方法并运行
      this.timeVal = this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date();

      let counts = parseInt(this.newGoodsData.counts), today_counts = parseInt(this.newGoodsData.today_counts)
      curList && curList.forEach(item => {
        if (item.id == goodItem.goods_id && item.sku == goodItem.sku) {
          this.currentGood = Object.assign(item, { counts: counts - today_counts })
        }
      })

      const good_item_options = goodItem.optionid.split("_");
      // console.log("[good_item_options].....", good_item_options);
      const finalAttr = this.currentGood["goods_attr_list"].length ? this.currentGood["goods_attr_list"] : false;
      const choosedData = this.getCartChoosedOption(finalAttr, good_item_options);

      const str_key_id = goodItem.sku + "-" + index + "-" + goodItem.goods_id;
      const str_key_qty = this.cart_productqty[str_key_id];

      //设置已选中的规格
      this.setRadioAddons(choosedData.attr);
      this.curChooseList = choosedData.mulattr;
      this.currentAttr = choosedData.mulattr;

      this.settingAttrRadio({ attr_list: finalAttr, choosed: goodItem });
      this.currentGood["isEdit"] = true;
      this.currentGood["choosedAttr"] = goodItem;
      this.qty = this.cart_productqty[str_key_id] || goodItem.qty;

      this.currentAttrTotal = this.fmPrice(goodItem.price * goodItem.qty);
      this.cartWinHeight = "100%";
      this.getCurrentAttrTotal();
      this.show = true;
    },
    setIsRequired (isRequired) {
      this.isRequired = isRequired
    },
    closeEditPopup () {
      this.show = false;
    },
    chooseEditAttr (attrOptions) {
      this.currentAttr = attrOptions.attr || null;
      this.isSelectedAttr = true;
      setTimeout(() => {
        this.getCurrentAttrTotal();
      }, 10);
    },
    updateAndSave () {
      let is_inventory = (parseInt(this.currentGood.counts) >= 1 && parseInt(this.qty) <= parseInt(this.currentGood.counts)) ? true : false
      if (parseInt(this.currentGood.counts) == -1) {
        is_inventory = true
      }
      if (is_inventory) {
        if (this.isRequired == false) {
          this.$toast('the require option can not empty')
        } else {
          const isChoosed = this.currentAttr ? true : false;
          const attr1 = {
            sky: this.currentGood.sky,
            sku: this.currentGood.sku,
            goodsid: this.currentGood.id,
            price: this.currentGood.marketprice,
            options: isChoosed ? this.currentAttr : 0,
            qty: this.qty,
            optionname: isChoosed ? this.getOptionName(this.currentAttr) : 0,
            optionid: isChoosed ? this.getOptionId(this.currentAttr) : ""
          };
          const objQuery = this.getUrlParams({ do: "UpdateDishNumOfCategory" });
          const updateOption = () => {
            const queryParams = Object.assign(objQuery, {
              optype: "",
              cart_id: this.cart_id,
              o2uNum: attr1.qty,
              optionid: attr1.optionid,
              dishid: attr1.goodsid
            });
            // console.log("购物车规格更新.queryParams", queryParams);
            updateDishnumOfCategory("/app/index.php", queryParams)
              .then(res => {
                const cartList =
                  res.message.cartList &&
                  res.message.cartList.length &&
                  res.message.cartList.filter(item => parseFloat(item.total) > 0);
                const apiResData = {
                  totalprice: res.message.totalprice,
                  totalcount: res.message.totalcount,
                  cart: cartList || []
                };
                if (parseInt(res.message.code) == 200) {
                  this.resetCart(apiResData);
                } else {
                  this.$toast(res.message.msg);
                }
              })
              .catch(error => {
                // console.log("购物车规格更新.error", error);
              });
          };
          updateOption && updateOption();
          this.closeEditPopup();
        }
      } else {
        // console.log('数量超出太多了');
      }
    },
    getCurrentAttrTotal () {
      setTimeout(() => {
        let attr_total = 0.0;
        if (this.currentGood) {
          attr_total = parseFloat(this.currentGood.marketprice);
        }
        this.currentAttr &&
          this.currentAttr.length &&
          this.currentAttr.forEach(priceItem => {
            attr_total = attr_total + parseFloat(priceItem.price);
          });
        this.currentAttrTotal = this.fmPrice(attr_total * this.qty);
      }, 10);
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.case-empty {
  display: flex;
  align-items: center;
  .case-empty-cart {
    flex: 1;
  }
}
.app-container {
  font-size: @size14;
  text-align: left;
  .empty-cart {
    color: #666666;
    font-size: 20px;
    text-align: center;
    img {
      width: 100px;
      padding: 5px;
      border-radius: 50%;
    }
    .empty-cart-btn {
      margin: 30px 20px 0 20px;
      background-color: @red;
      border-radius: 5px;
      padding: 10px 0;
      color: white;
    }
  }
  .content-container {
    .cart-item {
      padding: 5px 0;
      margin: 3px 0;
      .delete-icon {
        margin-right: 8px;
        color: @red;
      }
      .optionname-word {
        word-break: break-all;
        word-wrap: break-word;
      }
      .item-option-attr {
        color: #666666;
        font-size: 12px;
        border: 1px solid #cecece;
        padding: 0px 3px;
        margin: 2px;
        border-radius: 2px;
        display: inline-block;
      }
      .basic-price-qty {
        // flex-basis: 70px;
        .basic-qty {
          margin-left: 8px;
          margin-right: 8px;
          font-weight: bold;
        }
        .basic-price {
          font-weight: bold;
        }
      }
    }
  }
}

.edit-item-popup {
  background-color: #f0f0f0;
}

.attr-bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  box-shadow: 0px 17px 20px 10px rgba(146, 146, 146, 0.85),
    -10px 10px 10px 10px rgba(255, 255, 255, 0.5);
  .pos-bottom {
    padding: 8px;
    text-align: center;
    // background-color: #f6f6f6;
    text-align: center;
    .goods-inventory {
      margin: 10px 0;
      font-size: 14px;
      color: #07c160;
    }
    .select-quanity {
      text-align: center;
      font-weight: bold;
    }
    .btn-on-bg {
      background-color: @red;
    }
    .btn-off-bg {
      background-color: #6b6b6b;
    }
    .no-more-item {
      background-color: #a7a7a7 !important;
    }
    .confirm-btn {
      border-radius: 5px;
      margin: 10px 5px 20px 5px;
      color: @fff;
      padding: 14px 0px;
      font-size: 18px;
    }
  }
}
</style>